// extracted by mini-css-extract-plugin
export default {"actionButton":"quickActions_actionButton__pLTj9","reversed":"quickActions_reversed__zxtw2"};